import $ from 'jquery';
import { clarify } from '@/domain/services/VueDataProvider';
import pjax from '@/vendor/pjax/pjax';

/**
 * Provides an easy way to make a POST request from a <a> link click.
 */
const initLinkPoster = () => {
	$('body').on('click', '.link-poster', function (event) {
		event.preventDefault();

		const url = $(this).attr('href');

		let data = $(this).data('link-poster');
		data = data ? clarify(data) : {};
		data['_method'] = $(this).data('method');

		pjax.navigate({ url: url, data: data, type: 'POST' });
	});
};

export default initLinkPoster;
